import Paper, { type PaperProps } from '@mui/material/Paper';

export const Card = ({ children, ...props }: PaperProps): JSX.Element => {
  return (
    <Paper
      elevation={0}
      {...props}
      sx={{
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        borderRadius: 3,
        p: 3,
        color: 'text.primary',
        ...props.sx,
      }}
    >
      {children}
    </Paper>
  );
};
